/**
 * Created by saeed on 2/27/2017.
 */
import { Directive, ElementRef, HostListener, Input,OnChanges } from '@angular/core';
import {API_URL_IMAGE_BY_IMAGE_ID,API_URL_IMAGE_THUMB_BY_IMAGE_ID,DEFAULT_IMAGE_DIRECTORY} from '../../../services/constants';
import {CompanyService} from "../../../services/company-service/company-service";
import {CompanyVM} from "../../../models/CompanyVM.model";
@Directive({selector: '[imageBg]'})
export class ImageBgDirective {
  @Input() imageUseCase:string;
  @Input() imageBgImage:any;
  @Input() company:CompanyVM;
  @Input('is-thumb') isthumb:boolean = false;
  @Input() imageUrl:string;
  public element:any;

  constructor(el:ElementRef) {
    this.element = el;
  }

  ngOnChanges(changes) {

    if (this.imageBgImage) {

      //alert( this.imageBgImage.id);
      if (this.isthumb)
        this.element.nativeElement.style.backgroundImage = 'url("' + API_URL_IMAGE_THUMB_BY_IMAGE_ID + "?imageDataId=" + this.imageBgImage.id + '")';
      else
        this.element.nativeElement.style.backgroundImage = 'url("' + API_URL_IMAGE_BY_IMAGE_ID + "?imageDataId=" + this.imageBgImage.id + '")';

      this.element.nativeElement.style.backgroundRepeat = 'no-repeat';
    }
    else if(this.imageUrl)
    {

      this.element.nativeElement.style.backgroundImage = 'url("' + this.imageUrl + '")';

      this.element.nativeElement.style.backgroundRepeat = 'no-repeat';
    }
  }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/shared/image-components/image-bg.directive.ts